module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/eco-concious/mobile/MOBILEECOCONS_05_ecowater-cycle.png";